import { useContext } from 'react'
import { LabelCheckAnswerStoreContext } from '../contexts/LabelCheckAnswerStoreContext'

type Props = {
  children: React.ReactNode
}

export const useRenderLabelCheckAnswerForPDFProvider = () => {
  const { labelInspectionResultMap } = useContext(LabelCheckAnswerStoreContext)

  return {
    LabelCheckAnswerForPDFProvider: (props: Props) => (
      <LabelCheckAnswerStoreContext.Provider
        value={{
          labelInspectionResultMap,
        }}
      >
        {props.children}
      </LabelCheckAnswerStoreContext.Provider>
    ),
  }
}
